export const QUOTATION_STATUSES = {
  TEMPORARILY_ON_HOLD: 'temporarilyOnHold',
  ON_HOLD_WITHOUT_DEPOSIT: 'onHoldWithoutDeposit',
  ON_HOLD_WITH_DEPOSIT: 'onHoldWithDeposit'
};
